import { PaymentPlanLineStatus } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum } from '@/utils/zodUtils';

export const UpdatePaymentStatusSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      status: requiredEnum(PaymentPlanLineStatus, t),
    })
    .strict();

export type UpdatePaymentStatusType = z.infer<ReturnType<typeof UpdatePaymentStatusSchema>>;
